import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '../classes';
import { LocationService } from '../services/location.service';

@Pipe({
  name: 'location'
})
export class LocationPipe implements PipeTransform {

  constructor(private _locationService: LocationService){ }

  transform(locationId: number): Observable<string> {
    if(typeof locationId !== 'number') return null;
    return this._locationService.getLocationById(locationId, true).pipe(map((location: Location) => this._displayLocation(location)));
  }

  private _displayLocation(location: Location): string {
    if(location == null) return null;
    var parts = [];
    if(location.locationaddress) parts = [location.address.addressstreet, location.address.addresshousenumber];
    parts.push(location.locationfloor);
    return parts.join(' ');
  }

}
